module.exports = __webpack_public_path__ + "static/media/tictactoe.33137d39.png";